import classes from './Cube.module.css';

export const Cube = () => {
  return (
    <svg className={classes.container} viewBox="0 0 35 35" height="35" width="35">
      <rect
        className={classes.track}
        x="2.5"
        y="2.5"
        fill="none"
        strokeWidth="5px"
        width="32.5"
        height="32.5"
      />
      <rect
        className={classes.car}
        x="2.5"
        y="2.5"
        fill="none"
        strokeWidth="5px"
        width="32.5"
        height="32.5"
        pathLength="100"
      />
    </svg>
  );
};
